import React from 'react';
import { Field, NumericInput, TextOutput } from '../../../../../../Core';
import { ListFieldSection } from '../../../../../../Layout';
import { withInjectedProps, NamePrefixModifier } from '../../../../../../Core/InjectedPropsContext';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { WorksheetBalanceFieldSet } from '../../../../../Core/WorksheetEquipment';

let WholePortionDryMassesSection: React.FC<IWorksheetComponent> = () => (
  <NamePrefixModifier appendNamePrefix="Masses.MassMeasurement">
    <ListFieldSection>
      <WorksheetBalanceFieldSet label="Balance" name="Equipment.Balance" copyTo={['Equipment.DryMassBalance']} />
      <Field input={<NumericInput />} name="TareMass" label="Tare Mass" />
      <Field input={<NumericInput />} name="TareAndDryMass" label="Tare and Portion Dry Mass" />
      <Field input={<TextOutput />} name="DryMass" label="Portion Dry Mass" />
    </ListFieldSection>
  </NamePrefixModifier>
);

WholePortionDryMassesSection = withInjectedProps(WholePortionDryMassesSection);

export { WholePortionDryMassesSection };
export default WholePortionDryMassesSection;
